module.exports = "https://cdn-shared.mathletics.com/teacher-modules/school-usage-reports/89/assets/images/68cad50dfb195b18afb30ffcc16d20af.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/badges/Bronze/Bronze1.svg
// module id = 7BBg
// module chunks = 1